export const getApprovalNotifications = state => {
  return state.ui.notification.notifications.approval;
};
